import React, { useEffect,useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import {LoginPopupStyles }from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import { setUserNoBrandAddAction} from '../../modules/common/brandModule';
import { setNoBrandIdAction} from '../../modules/su/userBrandModule';
import {isMobileOnly} from 'react-device-detect';

const BrBrandNoRequestItemLiBlock = styled.li`
    ${isMobileOnly?`
        width: 44vw;
    `:`
        float: left;
        width: 214px;  
        margin-left: 24px;  
    `};
    height: 210px;
    padding: 30px 20px;    
    margin-bottom: 30px;
    background-color: #ececec;
    border-radius: 10px;
    text-align: center;
`;

const BrBrandNoRequestItemLogoPBlock = styled.p`
    margin-bottom: 8px;
`;

const BrBrandNoRequestItemImgBlock = styled.img`
    max-height: 28px;
`;
const BrBrandNoRequestItemTitleSpanBlock = styled.span`
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
`;

const BrBrandNoRequestItemButtonBlock = styled.button`
    width: 92px;
    line-height: 28px;
    height: 30px;
    margin-bottom: 20px;
    font-size: 14px;

    color: ${props => props.colorT || '#fff'};
    background-color: ${props => props.colorBG || '#111'};
    border: 1px solid ${props => props.colorBG || '#111'};

    border-radius: 20px;
    text-align: center;

    cursor: ${props => props.cursor};
`;

const BrBrandNoRequestItemInfoPBlock = styled.p`
    line-height: 1.5;
    color: #333;
    font-size: 14px;
    font-weight: 400;
    text-align: left;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const RequestStatus=[
    {text:'오픈 요청', color:'#fff', bgColor:'#111'},
    {text:'요청 완료', color:'#bbb', bgColor:'#e0e0e0'},
    {text:'오픈 예정', color:'#111', bgColor:'#fcc643'}
];

Modal.setAppElement('#modal-root');

const BrBrandNoRequestItem = ({ img, brandname, requestStatus, brandinfo, idHome}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [isNoAdd, setIsNoAdd] = useState(false);

    const { accessToken,id, brandNoAddResult, noBrandIds} = useSelector(
        ({ userReducer ,brandItemsReducer, userBrandReducer}) => ({
            accessToken: userReducer.accessToken,
            id: userReducer.id,
            brandNoAddResult: brandItemsReducer.brandNoAddResult,
            noBrandIds: userBrandReducer.noBrandIds,
        })
    );

    useEffect(() => {
        if(accessToken !== null){
            onCloseModal();
        }

        return ()=>{
            //console.log( "BrBrandNoRequestItem end = ");
        };

    }, [accessToken]);

    useEffect(() => {

        //console.log("BrBrandNoRequestItem" + JSON.stringify(noBrandIds))

        if(isNoAdd){
            if(noBrandIds === null || noBrandIds === undefined || (noBrandIds && noBrandIds.noBrandIds < 1)){
                let clipSum = [];
                clipSum.push(idHome);
                //console.log("BrBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setNoBrandIdAction(clipSum));
                setIsNoAdd(false);
            }
            else{
                let clipSum = [...new Set(noBrandIds.concat(idHome))];
                //console.log("BrBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setNoBrandIdAction(clipSum));
                setIsNoAdd(false);
            }
        }

    }, [brandNoAddResult]);

    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setOpenModal(false);
    }

    const onHandleRequest = (idHome) =>{
        //비로그인
        if (accessToken === null){
            onOpenModal();
        }
        else{
            if(noBrandIds != null && noBrandIds.length >0 && noBrandIds.includes(idHome)){

            }
            else{
                dispatch(setUserNoBrandAddAction(id,idHome));
                setIsNoAdd(true);
            }
        }
    }


    const getRequestText = ()=>{

            //if(getrequestStatus() < 3)
             return RequestStatus[getrequestStatus()];
    }

    const getrequestStatus = ()=>{
        if (accessToken === null){
            return 0;
        }
        else{
            if(noBrandIds != null && noBrandIds.length >0 && noBrandIds.includes(idHome)){
                return 1;
            }
            else{
                return 0;
            }
        }
    }

    // console.log("brandname : " + brandname);
    return (
        <BrBrandNoRequestItemLiBlock >
            <BrBrandNoRequestItemLogoPBlock>
                <BrBrandNoRequestItemImgBlock src={img}/>
            </BrBrandNoRequestItemLogoPBlock>
            <BrBrandNoRequestItemTitleSpanBlock>
            {brandname}
            </BrBrandNoRequestItemTitleSpanBlock>
            <BrBrandNoRequestItemButtonBlock colorT = {getRequestText().color}
                        colorBG = {getRequestText().bgColor} cursor={getrequestStatus() === 0 ? '' : "no-drop"}
                        onClick = {()=>onHandleRequest(idHome)}>
            {getRequestText().text}
            </BrBrandNoRequestItemButtonBlock>
            <BrBrandNoRequestItemInfoPBlock>
            {brandinfo}
            </BrBrandNoRequestItemInfoPBlock>

            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
                </Modal>

        </BrBrandNoRequestItemLiBlock>
    );
};

export default BrBrandNoRequestItem;
